import React, { InputHTMLAttributes, useState } from "react";
import { icon } from "@common/helpers/icons";
import { TextInputProps } from "@common/types";
import { TextInput } from "./TextInput";

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & TextInputProps
>(function PasswordInput({ ...props }, ref) {
  const [visible, setVisible] = useState(false);

  return (
    <TextInput
      {...props}
      ref={ref}
      type={visible ? "text" : "password"}
      iconPosition="end"
      icon={
        <div
          role="button"
          tabIndex={0}
          onClick={() => setVisible(!visible)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setVisible(!visible);
            }
          }}
          className="pointer-events-auto me-2 flex cursor-pointer items-center justify-center hover:text-foreground"
        >
          {icon("eye")}
          <div
            style={{
              width: visible ? 18 : 0,
              height: 2,
              background: "hsl(var(--muted-foreground))",
              transition: "width 0.3s ease 0s",
              position: "absolute",
              transform: "rotate(45deg) translateY(-50%)",
            }}
          />
        </div>
      }
    />
  );
});
